import React, { Component } from 'react';

import { Route, Switch, Redirect } from 'react-router-dom';

import Login from './components/Login';
import Register from './components/Register';
import PasswordReset from './components/PasswordReset';
import Donate from './components/Donate';
import App from './App';
import { auth } from './firebase';
import RsvpStatus from './components/RsvpStatus';
import Landing from './components/Landing/Index';

class Boot extends Component {
    constructor() {
        super();
        this.state = {
            loading: true,
        };
    }

    componentWillMount() {
        auth.onAuthStateChanged((user) => {
            if (user) {
                fakeAuth.isAuthenticated = true;
            } else {
                fakeAuth.isAuthenticated = false;
            }
            this.setState({
                loading: false,
            });
        });
    }

    render() {
        
        if(this.state.loading) {
            return(<h3>Loading...</h3>);
        }

        return (
            <Switch>
                <Route exact path='/login' component={Login} />
                <Route exact path='/register' component={Register} />
                <Route exact path='/reset' component={PasswordReset} />
                <Route path='/donate/:id' component={Donate} />
                <Route path='/rsvp/:id' component={RsvpStatus} />
                <PrivateRoute path='/' component={App}/>
            </Switch>
        );
    }
}

const fakeAuth = {
    isAuthenticated: true,
    authenticate(cb) {
        this.isAuthenticated = true;
        setTimeout(cb, 100); // fake async
    },
    signout(cb) {
        this.isAuthenticated = false;
        setTimeout(cb, 100);
    }
};

const PrivateRoute = ({ component: Component, ...rest }) => (
    <Route
        {...rest}
        render={props =>
            fakeAuth.isAuthenticated ? (
                <Component {...props} />
            ) : (
                    <Landing />
                )
        }
    />
);

export default Boot;



// WEBPACK FOOTER //
// ./src/Boot.js